import Rendable from '@/glxp/abstract/rendable'
import Shader from '@/glxp/utils/shader'
import Node from '@/glxp/abstract/node'
import Mouse from '@/js/utils/mouse'

import GEOM from '@/glxp/geom/plane'
import ShaderManifest from '../shaderManifest'
import { vec3 } from 'gl-matrix'

import Emitter from 'event-emitter'

class Hand extends Rendable {
    constructor(scene) {
        super(scene)

        this.gl = scene.gl
        this.scene = scene

        this.node = new Node()
        this.shader = new Shader(ShaderManifest['hand'])

        this.hasNormal = false
        this.initBuffer({
            vertices: GEOM.vertices,
            uvs: GEOM.uvs,
            indices: GEOM.indices
        })

        this.initProgram(this.shader.vert, this.shader.frag)
        this.initVao()
        this.initMatrix()
        this.createUniforms()

        this.animationIndex = 0

        this._emitter = {}
        Emitter(this._emitter)
        this.on = this._emitter.on.bind(this._emitter)

        this.node.position = vec3.fromValues(0, -0.8, -6)
        this.node.activateDamping(0.1 * this.scene.timeScale)
        this.node.scale = vec3.fromValues(0.4 * 0.9, 0.6 * 0.9, 1)
        
        window.addEventListener("keydown", (evt)=>{ this.onKeyEvent(evt) })
        if (this.scene.mobile) {
            Mouse.target.addEventListener('touchstart', (event) => { 
                let hit = (event.touches[0].clientX / Mouse.screenWidth - 0.5) * 2     
                if ( hit < -0.15) {
                    this.node.position[0] -= .45
                } else if ( hit > 0.15) {
                    this.node.position[0] += .45
                }
                this._emitter.emit('mouve')   
                this.node.position[0] = Math.min(Math.max(this.node.position[0], -.45), .45)
            })
        } else {
            Mouse.target.addEventListener('click', (event) => { 
                let hit = (event.clientX / Mouse.screenWidth - 0.5) * 2            
                if ( hit < -0.15) {
                    this.node.position[0] -= .45
                } else if ( hit > 0.15) {
                    this.node.position[0] += .45
                }
                this._emitter.emit('mouve')   
                this.node.position[0] = Math.min(Math.max(this.node.position[0], -.45), .45)
            })
        }

    }

    createUniforms() {
        this.createUniform('uTexture', 'texture')
        this.createUniform('uTime')
        this.createUniform('uAnimIndex')
    }

    applyState() {
        let gl = this.gl

        this.scene.applyDefaultState()

        gl.disable(gl.CULL_FACE)
        // gl.disable(gl.DEPTH_TEST)
        // gl.depthMask(false)
    }

    onKeyEvent(evt){
        // console.log(evt);
        if (evt.keyCode == 39) {
            this.node.position[0] += .45
            this._emitter.emit('mouve')   
        } else if (evt.keyCode == 37){
            this.node.position[0] -= .45
            this._emitter.emit('mouve')   
        }
        this.node.position[0] = Math.min(Math.max(this.node.position[0], -.45), .45)
    }

    preRender() {
        this.node.damping = Math.min(0.15 * this.scene.timeScale, 0.5)

        let v = this.node.positionVelocity[0]
        let intro = !this.scene.intro ? 0 : 3

        if (Math.abs(v) < 0.05) {
            this.animationIndex = 0 + intro
        } else if(v < 0) {
            this.animationIndex = 2 + intro
        } else if (v > 0) {
            this.animationIndex = 1 + intro
        }
    }

    render() {

        this.preRender()

        let gl = this.gl
        gl.useProgram(this.program)
        gl.bindVertexArray(this.vao)
        this.applyState()

        gl.activeTexture(gl.TEXTURE0)
        gl.bindTexture(gl.TEXTURE_2D, this.scene.textureLoader.getTexture('Hand_Sprite'))
        this.bindUniform('uTexture', 0)
        this.bindMatrixUniforms(this.scene.camera)

        this.bindUniform('uAnimIndex', this.animationIndex)
        this.bindUniform('uTime', (this.scene.time * 2) % 6)

        gl.drawElements(gl.TRIANGLES, GEOM.indices.length, gl.UNSIGNED_SHORT, 0)
        gl.bindVertexArray(null)
    }
}

export default Hand
